// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"9b167f93","929":"63d11e4c"}[chunkId] + ".chunk.css";
};